var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightTurquoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Arrow_Right_4",
    "data-name": "Icon - Arrow Right 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.741,
    viewBox: "0 0 14 13.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_-_Arrow_Right_4-2",
    "data-name": "Icon - Arrow Right 4",
    d: "M7.7,11.649Q9.266,9.106,10.9,6.62c-1.056-1.6-2.355-3.014-3.463-4.574C6.386.561,8.835-.849,9.874.622c1.288,1.818,2.835,3.435,3.957,5.368A1.53,1.53,0,0,1,13.5,7.8q-1.725,2.608-3.361,5.274a1.316,1.316,0,0,1-1.148.668A1.393,1.393,0,0,1,7.7,11.649Zm-7.183,0q1.565-2.542,3.2-5.029C2.664,5.029,1.364,3.611.258,2.049-.8.565,1.653-.84,2.692.621,3.98,2.44,5.526,4.056,6.65,5.989A1.53,1.53,0,0,1,6.318,7.8Q4.592,10.4,2.955,13.072a1.314,1.314,0,0,1-1.147.669A1.392,1.392,0,0,1,.52,11.653Z",
    transform: "translate(0 0)",
    fill: "#0baaa1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTurquoise);
export default __webpack_public_path__ + "static/media/arrow_right_turquoise.042fc78f2eea4838a50ee8eea7ee09e8.svg";
export { ForwardRef as ReactComponent };